import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton, TextButton } from '@bibliocommons/base-buttons';
import Checkbox from '@bibliocommons/base-checkbox';
import { FormattedMessage } from 'react-intl';
import BorrowingBatchActionsOverlay from '../../shared/BorrowingBatchActionsOverlay';
import { SHELF_NAMES } from '../../../../constants/ShelfConstants';

export default class BatchCancelOverlay extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      addToShelf: false
    };
    this.bindAll('handleToggleAddToShelf', 'handleBatchCancel');
  }

  handleToggleAddToShelf() {
    this.setState({ addToShelf: !this.state.addToShelf });
  }

  handleBatchCancel() {
    const { addToShelf } = this.state;
    const shelfState = addToShelf && {
      toAdd: true,
      name: SHELF_NAMES.FOR_LATER
    };

    this.props.handleBatchCancel({ shelfState });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoading && !this.props.isLoading) {
      this.props.handleClose();
    }
  }

  renderFooter() {
    return (
      <div className="edit-hold-date-submit">
        <PrimaryButton className="pull-left" handleClick={this.handleBatchCancel} isLoading={this.props.isLoading}>
          <FormattedMessage id="cancel_confirmation_holds_button_yes" />
        </PrimaryButton>
        <TextButton className="btn btn-link pull-left" handleClick={this.props.handleClose}>
          <FormattedMessage id="button_nevermind_close" />
        </TextButton>
      </div>
    );
  }

  renderShelfControls() {
    const shelfName = <FormattedMessage id="label_shelf_for_later" />;
    return this.props.showShelfControls && [
      <h4 key="shelf-controls-heading">
        <FormattedMessage id="keep_a_reference" />
      </h4>,
      <Checkbox
        key="shelf-controls-checkbox"
        id="batch-cancel-add-to-shelf"
        handleChange={this.handleToggleAddToShelf}
        checked={this.state.addToShelf}
        label={<FormattedMessage id="add_titles_to_shelf" values={{ shelfName }} />} />
    ];
  }

  render() {
    return (
      <BorrowingBatchActionsOverlay
        open={this.props.open}
        className="cp-batch-cancel-overlay"
        handleClose={this.props.handleClose}
        header={<FormattedMessage id="batch_cancel_holds_title" values={{ count: this.props.count }} />}
        subtitle={
          <div>
            <FormattedMessage tagName="p" id="your_position_will_be_lost" />
            <FormattedMessage tagName="p" id="action_cannot_be_undone" />
          </div>
        }
        footer={this.renderFooter()}>
        {this.renderShelfControls()}
      </BorrowingBatchActionsOverlay>
    );
  }
}

BatchCancelOverlay.propTypes = {
  count: PropTypes.number,
  open: PropTypes.bool,
  showShelfControls: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleClose: PropTypes.func,
  handleBatchCancel: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/BatchCancelOverlay/BatchCancelOverlay.jsx